export const PACKAGE_NAME = 'jiraSoftwareOnboardingInvites';

export const TEAM_NAME = 'jlove-makkuro';

export const IMPORT_BUTTON_TEST_ID = 'software-onboarding-invites.ui.import-work-button.button';
